module.exports = "<div class=\"premium-page\">\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/premium/premium-page.component.html
// module id = 273
// module chunks = 0